import { z } from 'zod'

const MAX_INPUT_LENGTH = 3000

export const ADVANCED_FOLLOW_UP_NOTE_FORM_SCHEMA = z.object({
  date: z.string(),
  SUBJECTIVE: z.object({
    CHIEF_CONCERN: z.string().max(MAX_INPUT_LENGTH).optional(),
    UPDATES_SINCE_LAST_VISIT: z.string().max(MAX_INPUT_LENGTH).optional(),
    MENTAL_HEALTH_STATUS: z.string().max(MAX_INPUT_LENGTH).optional(),
    PHYSICAL_SYMPTOMS: z.string().max(MAX_INPUT_LENGTH).optional(),
    MEDICATION_SUPPLEMENT_UPDATES: z.string().max(MAX_INPUT_LENGTH).optional(),
    SAFETY_CONCERNS: z.string().max(MAX_INPUT_LENGTH).optional(),
  }),
  OBJECTIVE: z.object({
    RELEVANT_METRICS_OR_LABS: z.string().max(MAX_INPUT_LENGTH).optional(),
    BEHAVIORAL_OBSERVATIONS_OR_OTHER_PERTINENT_FINDINGS: z.string().max(MAX_INPUT_LENGTH).optional(),
  }),
  ASSESSMENT: z.object({
    CLINICAL_SUMMARY: z.string().max(MAX_INPUT_LENGTH).optional(),
  }),
  PLAN: z.object({
    FOCUS_AREAS: z.string().max(MAX_INPUT_LENGTH).optional(),
    LIFESTYLE_GOALS: z.string().max(MAX_INPUT_LENGTH).optional(),
    NUTRITION_METABOLIC_ADJUSTMENTS: z.string().max(MAX_INPUT_LENGTH).optional(),
    MENTAL_HEALTH_SOMATIC_TOOLS: z.string().max(MAX_INPUT_LENGTH).optional(),
    MEDICATIONS_SUPPLEMENTS: z.string().max(MAX_INPUT_LENGTH).optional(),
    REFERRALS_ESCALATION: z.string().max(MAX_INPUT_LENGTH).optional(),
    NEXT_SCHEDULED_SESSION: z.string().max(MAX_INPUT_LENGTH).optional(),
    PATIENT_EXPRESSED_UNDERSTANDING: z.boolean().optional(),
    PATIENT_AGREES_WITH_PLAN: z.boolean().optional(),
  }),
})

export type AdvancedFollowUpNoteFormType = z.infer<typeof ADVANCED_FOLLOW_UP_NOTE_FORM_SCHEMA>
